export default "__VITE_ASSET__9e02df9b__"